import { GuidUtils } from "~app/common/utils/guid-utils";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IMapGeometry, IMapLayer } from "../../../../map.settings";
import { IGeometryMetadata } from "../../../../services/map-edit.service";

export class GeometryInformation {
    geometry: IMapGeometry;
    metadata: IGeometryMetadata;
    layer: IMapLayer;
    checked: boolean;
    label: string;
    tooltip: string;
    layerName: string;
    readonly: boolean;
    attributes: any[];
    id: any;
    constructor(geometry: IMapGeometry, metadata: IGeometryMetadata, layer?: IMapLayer) {
        const layerName = this.getLayerName(metadata, layer);
        this.id = GuidUtils.newGuid();
        geometry.id = this.id;
        if (!geometry.attributes) {
            geometry.attributes = {};
        }
        geometry.attributes.id = this.id;
        geometry.visible = true;
        this.geometry = geometry;
        this.metadata = metadata;
        this.layer = layer;
        this.label = `${this.getLabel(geometry)} - ${layerName}`;
        this.tooltip = this.getTooltip(geometry, metadata, layer);
        this.layerName = layerName;
        this.readonly = true;
        this.attributes = this.getAttributesAsArray();
    }

    getAttributesAsArray() {
        const attributes = this.geometry?.attributes;
        const keyvalues = [];
        for (const key in attributes) {
            if (Object.hasOwn(attributes, key)) {
                keyvalues.push({
                    key: key,
                    value: attributes[key]
                });
            }
        }
        return keyvalues;
    }

    private getLabel(geo: IMapGeometry): string {
        if (!geo.attributes) {
            return "";
        }
        const testKeys: string[] = [
            "label",
            "Namn",
            "NAME",
            "NAMN",
            "Beteckning",
            "DISTRNAMN",
            "FORSAMNAMN",
            "ANT",
            "KALLA",
            "fastighet",
            "Transportforetag_Namn",
            "LAMNINGTYP",
            "typ"
        ];
        const found = testKeys.filter(k => (geo.attributes[k] || Object.hasOwn(geo.attributes, k)) && ObjectUtils.hasValue(geo.attributes[k]))?.map(k => geo.attributes[k]);
        return found && found.length > 0 ? found[0] : "Namnlös";
    }

    private getTooltip(geo: IMapGeometry, metadata: IGeometryMetadata, layer: IMapLayer): string {
        const layerName = this.getLayerName(metadata, layer);
        switch (metadata?.type) {
            case "polygon":
            case "multipolygon":
                return `Yta: ${metadata.area.toFixed(0)} km² ${layerName}`;
            case "line":
            case "polyline":
                return `Linje: ${metadata.length.toFixed(0)} ${layerName}`;
            case "point":
                return `Punkt: ${layerName}`;
            default:
                return `${metadata?.type} ${layerName}`;
        }
    }

    private getLayerName(metadata: IGeometryMetadata, layer: IMapLayer) {
        return `${(metadata?.sublayername ?? metadata?.sublayer) ?? layer?.title}`;
    }
}
